export default __webpack_public_path__ + "static/media/Chalkduster.9ff31f6c.ttf";